import { BuiltinInterface } from '../BuiltinInterface';
class ArgumentsInstance extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('IArguments', new ArgumentsInstance());
};

//# sourceMappingURL=index.js.map
